//import 'core-js/stable';
//import 'regenerator-runtime/runtime';

//import '@babel/polyfill';
import $ from 'jquery';
import 'url-search-params-polyfill';

// bootstrap plugins
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/tooltip';
import Common from './base/common';
import Validation from './base/validation';
import Layout from './base/layout';
import Hero from './components/hero';
import Accordion from './components/accordion';
import Tabs from './components/tabs';
import Carousel from './components/carousel';
import JumpTo from './components/jumpTo';
import Modal from './components/modal';
import Banner from './components/banner';
//import Lightbox from './components/lightbox';
import Countdown from './components/countdown';
import Minimenus from './components/minimenus';
import Home from './pages/home';
import PageBuilder from './components/pagebuilder';
import FormTools from './utils/formTools';
import StateSelect from './components/state-variable-select';
import Newsletter from './components/newsletter';
import SearchPage from './pages/search';
import Testimonials from './components/testimonials';
import TrendReports from './pages/trendreports';
import Solc from './pages/solc/solc';
import './common/components/webpimages';
import './common/components/lazyload';
import Tables from './components/tables';
import Timeline from './components/timeline';
import LFCYLandingPage from './components/lfcy-stat-items';
import HealthIndexWheel from './components/health-index-wheel';
import BackToHealthPage from './components/back-to-health';

window.FormTools = new FormTools(); // required for form builder
window.Carousel = Carousel; // required for pagebuilder

$(() => {
    const common = new Common();
    common.init();

    const validation = new Validation();
    validation.init();

    const layout = new Layout();
    layout.init();

    const carousel = new Carousel();
    carousel.initPageBuilder();

    const jumpto = new JumpTo();
    jumpto.init();

    const hero = new Hero();
    hero.init();

    const accordion = new Accordion();
    accordion.init();

    const tabs = new Tabs();
    tabs.init();

    const modal = new Modal();
    modal.init();

    const banner = new Banner();
    banner.init();

    //const lightbox = new Lightbox();
    //lightbox.init();

    const countdown = new Countdown();
    countdown.init();

    const minimenus = new Minimenus();
    minimenus.init();

    if ($('.hero--home').length) {
        const home = new Home();
        home.init();
    }

    const pagebuilder = new PageBuilder();
    pagebuilder.init();

    const newsletter = new Newsletter();
    newsletter.init();

    const searchPage = new SearchPage();
    searchPage.init();

    const stateSelect = new StateSelect();
    stateSelect.init();

    const trendreports = new TrendReports();
    trendreports.init();

    const solc = new Solc();
    solc.init();

    const tables = new Tables();
    tables.init();

    const timeline = new Timeline();
    timeline.init();

    window.FormTools.init();
});